export default {
  path: '/zpyy',
  name: 'AddMergeInvoice',
  meta: { title: '增票预约' },
  component: () => import('@/views/Invoice/AddMerge'),
  children: [
    {
      path: '',
      name: 'AddMergeInvoiceFilter',
      meta: { title: '增票预约' },
      component: () => import('@/views/Invoice/AddMerge/Filter')
    },
    {
      path: 'trans',
      name: 'AddMergeInvoiceTrans',
      meta: { title: '增票预约' },
      component: () => import('@/views/Invoice/AddMerge/List')
    },
    {
      path: 'input',
      name: 'AddMergeInvoiceInput',
      meta: { title: '增票预约' },
      component: () => import('@/views/Invoice/AddMerge/Input')
    },
    {
      path: 'result',
      name: 'AddMergeInvoiceResult',
      meta: { title: '增票预约' },
      component: () => import('@/views/Invoice/AddMerge/Result')
    },
    {
      path: 'order',
      name: 'AddMergeInvoiceOrderFilter',
      meta: { title: '预约记录' },
      component: () => import('@/views/Invoice/AddMerge/OrderFilter')
    },
    {
      path: 'list',
      name: 'AddMergeInvoiceOrderList',
      meta: { title: '预约记录' },
      component: () => import('@/views/Invoice/AddMerge/OrderList')
    },
    {
      path: 'detail',
      name: 'AddMergeInvoiceOrderDetail',
      meta: { title: '预约记录' },
      component: () => import('@/views/Invoice/AddMerge/OrderDetail')
    },
    {
      path: 'kdi',
      name: 'AddMergeInvoiceOrderKdi',
      meta: { title: '物流详情' },
      component: () => import('@/views/Invoice/AddMerge/Kdi')
    },
    {
      path: 'schede',
      name: 'AddMergeInvoiceOrschede',
      meta: { title: '定时开票' },
      component: () => import('@/views/Invoice/AddMerge/Schede')
    }
  ]
}
